import type { ElibooApi } from "@eliboo/api-models";

import { inject } from "@angular/core";
import { type ActivatedRouteSnapshot, RedirectCommand, type ResolveFn, Router, type RouterStateSnapshot } from "@angular/router";
import { MICRO_ROUTE_HOST } from "@eliboo/micro-ng/router";
import { TuiAlertService } from "@taiga-ui/core";
import { of } from "rxjs";

import { getTaxEnv } from "../environments";
import { TaxUserService } from "../service";

export const RenewalResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  console.log('invoiceResolver', route, state);
  const host = inject(MICRO_ROUTE_HOST);
  const taxUserService = inject(TaxUserService);
  const custDto = taxUserService.user()?.custDTO
  const router = inject(Router);
  const alerts = inject(TuiAlertService);
  const env = getTaxEnv()
  console.log("associationId", taxUserService.channelOperatorInfoId());
  if (!custDto) {
    return true;
  }

  if (!isNeedRenewal(custDto) && env.production) {
    alerts.open('未到续期时间，无需续期').subscribe();
    return of(new RedirectCommand(router.parseUrl(`${host}/main/tax`)));
    // return of(new RedirectCommand(router.parseUrl(`${host}/biz/renewal?isExpired=true`)));
  }
  return true;
};
export function isNeedRenewal(custDTO: Partial<ElibooApi.LdCcaseGetCustDto>) {
  // 没有客户信息，无需续费
  if (!custDTO) return false;

  // 安全获取日期字段，避免空值导致Invalid Date
  const startDate = custDTO.startDate;
  const endDate = custDTO.endDate;
  if (!startDate || !endDate) return false;

  const current = new Date();
  const endDateTime = new Date(endDate);

  // 计算当前时间到结束日期的剩余天数（毫秒转天数，向上取整）
  const timeDiff = endDateTime.getTime() - current.getTime();
  const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

  // 核心续费判断：超出期限 或 临期60天内（已过开始时间才判定临期）
  const isOverdue = current >= endDateTime; // 超出服务期限
  const isNearDeadline = daysRemaining <= 60 && current >= new Date(startDate); // 临近60天且已开始服务

  return isOverdue || isNearDeadline;
}

